import styled from '@emotion/styled'
import { layout } from './system-props'

const Box = styled('div')`
  box-sizing: border-box;
  ${layout}
`

export default Box
